import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ComponentVariantTransform, type Variants } from '../../utils/variant/variant';

@Component({
  selector: 'rt-divider',
  templateUrl: './divider.component.html',
  styleUrls: ['./divider.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.has-no-margin]': 'hasNoMargin()',
    '[class]': 'variant()',
  },
  standalone: true,
})
export class DividerComponent {
  public static readonly VARIANTS: Variants = [
    'line',
    [
      'line',
      'medium',
      'default',
      'large',
      'dot',
      'transparent',
      'dark',
      'square',
      'light',
      'disabled',
      'tint',
      'solid',
    ],
  ];

  public readonly variant = input(...ComponentVariantTransform(DividerComponent.VARIANTS));
  public readonly hasNoMargin = input<boolean>(false);
}
